import { render, staticRenderFns } from "./koniptList.vue?vue&type=template&id=3e564813&scoped=true"
import script from "./koniptList.vue?vue&type=script&lang=js"
export * from "./koniptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e564813",
  null
  
)

export default component.exports